export default __webpack_public_path__ + "static/media/digi_white.41032494.png";